import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { selectDescontoPixDoContexto } from "../../store/ducks/deliveryContext";
import { descontoNoPix, formatarPercentual } from "../../util/pixPrice";
import { Link } from "react-router-dom";
import BuyStepsTemplate from "../../components/BuyStepsTemplate";
import Breadcrumb from "../../components/Breadcrumb";
import HelmetCustom from "../../components/HelmetCustom";
import { Creators as CartActions } from "../../store/ducks/cart";
import {
  AssistedSaleMessage,
  ButtonFooterWrap,
  ContainerPageCart,
  ContentWrap,
  EmptyCartIconCircle,
  EmptyCartMessageContainer,
  EmptyCartWrap,
  GoBackButton,
  NoRewardsProgramMessage,
  PageTitle,
  PriceInfoContent,
  PriceInfoWrap,
  StyledButtonSecondary,
  TitleWrap,
  Wrap
} from "./styles";
import "./styles.css";

import { formatPrice, textoQuantidadeProdutos } from "../../util/format";

import { FiHeadphones, FiShoppingBag, FiX } from "react-icons/fi";
import "react-toastify/dist/ReactToastify.css";
import ProductCard from "../../components/ProductCard";
import FreeShippingProgress from "../../components/FreeShippingProgress";
import OrderMinimumNotice from "../../components/OrderMinimumNotice";
import { faltaParaPedidoMinimo } from "../../util/orderMinimum";
import { getExtractProductsCart as getProductsExtractCart, getPromotionsSubtotal, getPromotionsTotal, isAlternativePriceType } from "../../util/price";
import { PriceType } from "../../util/priceType";
import api from "../../services/api";

export default function Cart({ history }) {
  const dispatch = useDispatch();
  const [alert, setAlert] = useState(true);
  const [productsCount, setProductsCount] = useState(0);
  const [promotions, setPromotions] = useState([])
  const [subtotal, setSubtotal] = useState(0)
  const [total, setTotal] = useState(0)
  // Desconto do Pix online da farmácia do contexto, informativo abaixo do total (P-113)
  const descontoPixContexto = useSelector(selectDescontoPixDoContexto, shallowEqual)
  // Abaixo do piso do provedor o Pix online não está disponível: sem a linha
  const pisoPagamentoOnline = useSelector(state => Number(state.store.data?.empresa?.valor_minimo_pagamento_online) || 0)
  const percPix = descontoPixContexto.conhecida && total >= pisoPagamentoOnline ? descontoPixContexto.perc : 0
  const descontoPix = descontoNoPix(total, percPix)
  // Pedido mínimo da loja (decisão 0017): sem atingir, não avança
  const valorMinimoPedido = useSelector(state => state.store.data?.empresa?.valor_minimo_pedido)
  const faltaMinimo = faltaParaPedidoMinimo(total, valorMinimoPedido)
  const [regraFreteGratis, setRegraFreteGratis] = useState(null);
  const regraFreteGratisCacheRef = useRef({});

  const signed = useSelector((state) => state.auth.signed);
  const { programa_fidelidade = false } = useSelector((state) =>
    state.user.profile == null ? false : state.user.profile
  );

  const { loading: loadingItemInCart, productIdChanged } = useSelector(state => state.cart);

  const programa_fidelidade_nome = useSelector((state) =>
    state.store.data == null
      ? "Programa de Fidelidade"
      : state.store.data.empresa.programa_fidelidade_nome
  );

  const {
    data: basket,
  } = useSelector((state) => state.cart);

  useEffect(() => {
    dispatch(CartActions.getStorage());
  }, []);

  useEffect(() => {
    const { promotions, distinctProductsIdCount } = getProductsExtractCart(basket.itens, programa_fidelidade)
    setProductsCount(distinctProductsIdCount)
    setPromotions(promotions)
    setSubtotal(getPromotionsSubtotal(promotions))
    setTotal(getPromotionsTotal(promotions))
  }, [basket, programa_fidelidade])

  useEffect(() => {
    let ativo = true;
    let lojaId = null;
    try {
      const salvado = JSON.parse(localStorage.getItem("@ConexaoGAM:checkout")) || {};
      lojaId = salvado?.dadosEntrega?.lojaSelecionada?.id ?? null;
    } catch (e) {
      lojaId = null;
    }
    const chave = String(lojaId ?? "geral");
    if (regraFreteGratisCacheRef.current[chave]) {
      setRegraFreteGratis(regraFreteGratisCacheRef.current[chave]);
      return () => {
        ativo = false;
      };
    }
    api
      .get("/stores/free-shipping-rules", { params: lojaId ? { lojaId } : {} })
      .then((response) => {
        regraFreteGratisCacheRef.current[chave] = response.data;
        if (ativo) setRegraFreteGratis(response.data);
      })
      .catch(() => {});
    return () => {
      ativo = false;
    };
  }, []);

  const canHandlePromotionQuantity = (promotion, index) => {
    const hasNormalPriceForProduct = promotions.some(p => p.productId === promotion.productId && p.type === PriceType.NORMAL)
    const firstProductPromotionIndex = promotions.findIndex(p => p.productId === promotion.productId)

    return promotion.type === PriceType.NORMAL ||
      (index === firstProductPromotionIndex && isAlternativePriceType(promotion.type) && !hasNormalPriceForProduct)
  }

  if (promotions && promotions.length > 0) {
    return (
      <BuyStepsTemplate step={1} history={history}>
        <HelmetCustom pageTitle="Cesta" />
        <ContainerPageCart>
          <div className="produtcs-and-offers">
            <Breadcrumb items={[{ name: "Cesta de compras" }]} jsonLd={false} />
            <PageTitle>Minha cesta ({productsCount})</PageTitle>

            {/* Carrinho de venda assistida: substituiu o que o cliente tinha montado (P-060). */}
            {signed && basket?.vendaAssistida && (
              <AssistedSaleMessage>
                <FiHeadphones />
                <span>Sua cesta foi montada pelo atendimento da farmácia.</span>
              </AssistedSaleMessage>
            )}

            {signed && !programa_fidelidade && alert && (
              <NoRewardsProgramMessage>
                <span>
                  Aproveite os preços diferenciados para quem tem{" "}
                  {programa_fidelidade_nome}!{" "}
                  <Link to="/painel/programa-fidelidade">Quero participar</Link>
                </span>
                <button onClick={() => setAlert(!alert)}>
                  <FiX />
                </button>
              </NoRewardsProgramMessage>
            )}
            <ContentWrap>
              <Wrap>
                {promotions.map((promotion, index) => (
                  <ProductCard key={promotion.priceId} index={`price-${promotion.priceId}`} promotion={promotion} allowHandleQuantity={canHandlePromotionQuantity(promotion, index)} loadingItemInCart={loadingItemInCart} productIdInChanging={productIdChanged} />
                ))}
              </Wrap>
              <PriceInfoWrap>
                <TitleWrap>Resumo do pedido</TitleWrap>
                <PriceInfoContent>
                  <span className="price-description">Subtotal ({textoQuantidadeProdutos(productsCount)})</span>
                  <span className="price-value">{formatPrice(subtotal)}</span>
                </PriceInfoContent>

                {subtotal > total && (
                  <PriceInfoContent className="discount">
                    <span className="price-description">Descontos</span>
                    <span className="price-value">- {formatPrice(subtotal - total)}</span>
                  </PriceInfoContent>
                )}

                <OrderMinimumNotice valorMinimo={valorMinimoPedido} base={total} />

                {regraFreteGratis?.ativo && regraFreteGratis?.exibirMedidor && (
                  <FreeShippingProgress
                    valorMinimo={parseFloat(regraFreteGratis.valorMinimo)}
                    base={total}
                  />
                )}

                <PriceInfoContent className="total">
                  <span className="price-description total">
                    Total
                  </span>
                  <span className="price-value total">{formatPrice(total)}</span>
                </PriceInfoContent>

                {descontoPix > 0 && (
                  <PriceInfoContent className="pix-discount">
                    <span className="price-description">No Pix ({formatarPercentual(percPix)}% OFF nos produtos)</span>
                    <span className="price-value">- {formatPrice(descontoPix)}</span>
                  </PriceInfoContent>
                )}

                <ButtonFooterWrap
                  id="btn-prosseguir"
                  disabled={faltaMinimo > 0}
                  onClick={() => {
                    if (!signed)
                      return history.push("/entrar", {
                        previousPage: history.location.pathname,
                      });
                    history.push("/checkout/revisao");
                  }}
                >
                  Avançar
                </ButtonFooterWrap>
                <StyledButtonSecondary text={"Continuar comprando"} onClick={() => history.push("/")} />
              </PriceInfoWrap>
            </ContentWrap>
          </div>
        </ContainerPageCart>
      </BuyStepsTemplate>

    );
  } else {
    return (
      <>
        <BuyStepsTemplate step={1} history={history}>
          <HelmetCustom pageTitle="Cesta" />
          <EmptyCartWrap>
            <EmptyCartIconCircle>
              <FiShoppingBag />
            </EmptyCartIconCircle>
            <EmptyCartMessageContainer>
              <h1>Sua cesta está vazia</h1>
              <span>Adicione produtos para começar.</span>
            </EmptyCartMessageContainer>
            <Link to="/">
              <GoBackButton text="Ver produtos" />
            </Link>
          </EmptyCartWrap>
        </BuyStepsTemplate>
      </>
    );
  }
}
